// extracted by mini-css-extract-plugin
module.exports = {"image":"UploadcareImg-module_image_3V1_e"};